import { render } from "./cloudflare_image_section.vue?vue&type=template&id=0d6e8d7a&scoped=true"
import script from "./cloudflare_image_section.vue?vue&type=script&lang=js"
export * from "./cloudflare_image_section.vue?vue&type=script&lang=js"

import "./cloudflare_image_section.vue?vue&type=style&index=0&id=0d6e8d7a&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/v8-development-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d6e8d7a"]])

export default __exports__